import Sviatok from '../model/ciselniky/Sviatok';
import SablonaProcesu from '../model/ciselniky/SablonaProcesu';

const oneDay = 1;
const millisecondsInDay = 24 * 60 * 60 * 1000;
const sunday = 0;
const saturday = 6;

function datePlusDays(date: Date, days: number): Date {
  const now = new Date();
  if (date == null) {
    return now;
  }
  return new Date(date.valueOf() + millisecondsInDay * days);
}

function isAfter18Hours(): boolean {
  const now = new Date();
  return now.getHours() >= 18 && now.getMinutes() >= 0;
}

function isToday(date: Date): boolean {
  const now = new Date();
  if (date == null) {
    return true;
  }
  return now.getFullYear() === date.getFullYear()
    && now.getMonth() === date.getMonth()
    && now.getDate() === date.getDate();
}

function isBefore(date: Date): boolean {
  const now = new Date();
  if (date == null) {
    return true;
  }
  return date < now;
}

function isSviatok(date: Date, sviatky: Sviatok[]): boolean {
  if (date == null) {
    return false;
  }
  const dayOfTheWeek = date.getDay();
  const sviatkyDates: Date[] = sviatky?.map(it => (it.datum));
  let datesOnSviatky = sviatkyDates?.filter((sviatok) => sviatok.getFullYear() === date.getFullYear()
    && sviatok.getMonth() === date.getMonth()
    && sviatok.getDate() === date.getDate());
  datesOnSviatky = !datesOnSviatky ? [] : datesOnSviatky;
  return dayOfTheWeek === saturday || dayOfTheWeek === sunday || datesOnSviatky.length !== 0;
}

function getDurations(sablona: SablonaProcesu, skratene = false): Map<number, string> {
  const durations = new Map<number, string>();
  if (skratene) {
    for (let duration = sablona.lehotaSkratenaOd; duration <= sablona.lehotaSkratenaDo; duration += 1) {
      durations.set(duration, getDurationLabel(duration));
    }
  } else {
    for (let duration = sablona.lehotaOd; duration <= sablona.lehotaDo; duration += 1) {
      durations.set(duration, getDurationLabel(duration));
    }
  }
  return durations;
}

function getInitialConfigDuration(startDate: Date, endDate: Date, sviatky: Sviatok[]): number {
  let currentDate = startDate || new Date();
  let daysDifference = 0;

  while (currentDate <= endDate) {
    if (!isSviatok(currentDate, sviatky)) {
      daysDifference += 1;
    }
    currentDate = datePlusDays(currentDate, 1);
  }

  return daysDifference;
}

function getDurationLabel(duration: number): string {
  if (duration === 1) {
    return '1 pracovný deň';
  }
  if (duration < 5) {
    return `${duration} pracovné dni`;
  }
  return `${duration} pracovných dní`;
}

function includeSviatkyInEndDate(startDate: Date, endDate: Date, sviatky: Sviatok[]): Date {
  let dateToCheck = isSviatok(startDate, sviatky) ? datePlusDays(startDate, oneDay) : startDate;
  let endDateIncludingSviatky = isSviatok(startDate, sviatky) ? datePlusDays(endDate, oneDay) : endDate;

  while (dateToCheck <= endDateIncludingSviatky) {
    if (isSviatok(dateToCheck, sviatky)) {
      endDateIncludingSviatky = datePlusDays(endDateIncludingSviatky, oneDay);
    }
    dateToCheck = datePlusDays(dateToCheck, oneDay);
  }
  return endDateIncludingSviatky;
}

export {
  includeSviatkyInEndDate, getDurations,
  isSviatok, isToday, isAfter18Hours, isBefore, datePlusDays,
  getInitialConfigDuration,
};
